module.exports = __webpack_public_path__ + "img/29.1def368.webp";